/* src/app/forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component.scss */
.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content > * {
  width: 100%;
}
.full {
  width: 100% !important;
}
.main-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
form {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
nz-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
:host ::ng-deep .ant-card-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-header-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  color: var(--tem-ink);
}
.fields {
  height: 100%;
}
.buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 6px;
  justify-content: flex-end;
}
/*# sourceMappingURL=custom-action-parameters.component.css.map */
